<template>
  <div class="fab-container">
    <div class="fab-container-button">
      <a-popover placement="right">
        <template #content>
          <div class="fab-popover-content">
            <div class="fab-popover-item" @click="copy">
              <img class="fab-popover-item-img" src="./../assets/image/copyLink.png" alt="">
              <span>复制链接</span>
            </div>
            <a-popover placement="right" class="fab-container-qrcode">
              <template #content>
                <div class="qr-code">
                  <vue-qrcode :value="url" :options="{ width: 120 }" class="qr-img" />
                  <span>微信扫码分享</span>
                </div>
              </template>
              <div class="fab-popover-item">
                <img class="fab-popover-item-img" src="./../assets/image/weixin.png" alt="">
                <span>微信</span>
              </div>
            </a-popover>

          </div>
        </template>

        <div class="share-Icon">
          <span class="iconfont icon-share"></span>
        </div>
      </a-popover>

    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import useClipboard from 'vue-clipboard3';
import { message } from 'ant-design-vue';
const props = defineProps({
  // 距离右侧距离
  left: {
    type: Number,
    default: 24
  },
  // 距离底部距离
  top: {
    type: Number,
    default: 24
  },
  // 按钮大小
  size: {
    type: String,
    default: 'large',
    validator: (value) => ['small', 'middle', 'large'].includes(value)
  },
  // 图标类型
  icon: {
    type: String,
    default: 'plus'
  },
  // 悬浮提示文字
  tooltip: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['click']);
const { toClipboard } = useClipboard();
const router = useRouter()
const route = useRoute()

const url = computed(() => {

  return `${location.origin}#${route.fullPath}`
})

const copy = async () => {
  try {
    await toClipboard(url.value);
    message.success('复制成功');
  } catch (e) {
    message.error(`复制失败: ${e}`);
  }
};


const containerStyle = computed(() => ({
  left: `${props.left}px`,
  top: `${props.top}px`
}));



onMounted(() => {

});
</script>

<style scoped lang="less">
.fab-container {
  position: fixed;
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.fab-button {
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.fab-button:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.16),
    0 9px 28px 0 rgba(0, 0, 0, 0.12),
    0 12px 48px 16px rgba(0, 0, 0, 0.09);
}

.fab-button:active {
  transform: scale(0.98);
}

.fab-container-button {
  cursor: pointer;
}

.fab-popover-content {
  display: flex;
  flex-direction: column;

  border-radius: 5px;

  padding: 5px;
}

.fab-popover-item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 8px;
}

.fab-popover-item:hover {
  background: #f8f8f8;
}

.fab-popover-item-img {
  width: 20px;
  height: 20px;
}

.qr-code {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.share-Icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-size: 26px;
  }
}

.share-Icon:hover {
  background: #f5f5f5;
}
</style>
